import * as Const from '../constants/index';
import State from '../interfaces/state/AvatarState';

const initState: State = {
  avatar: '',
  isLoading: false,
  isError: false,
};

export default function avatar(state: State = initState, action: any): State {
  switch (action.type) {
    case Const.AVATAR_INIT:
    case Const.INIT_ALL_APP:
      return {
        ...initState,
      };

    case Const.AVATAR_LOADED:
      return {
        ...state,
        avatar: action.payload,
        isLoading: false,
        isError: false,
      };

    case Const.AVATAR_ERROR:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };

    case Const.AVATAR_PENDING:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };

    case Const.AVATAR_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
      };
    default:
      return state;
  }
}
